module.exports = __webpack_public_path__ + "img/Literacy Lab Station Overview.7d757a86.png";